export const baseURLs = {
    local: 'http://localhost:3099/roboadvisor/v1',
    preview: 'https://gateway.preview.brandnewday.nl/roboadvisor/v1',
    production: 'https://devrobotapi.azurewebsites.net/roboadvisor/v1',
};

export const getBaseURL = () => {
    switch (process.env.REACT_APP_ENDPOINT_ENVIRONMENT) {
        case 'LOCAL':
            return baseURLs.local;
        case 'PREVIEW':
            return baseURLs.preview;
        case 'PRODUCTION':
            return baseURLs.production;
        default:
            return process.env.NODE_ENV === 'production' ? baseURLs.production : baseURLs.preview;
    }
};

export const buildEndpoint = (segments: string[], queryParams?: { key: string; value: string }[]) => {
    const params = queryParams ? new URLSearchParams(queryParams.map((q) => [q.key, q.value])) : undefined;
    return `${getBaseURL()}/${segments.join('/')}${queryParams ? '?' + params : ''}`;
};
